// extracted by mini-css-extract-plugin
module.exports = {"comments":"Y_d5","comments__list":"Y_d6"};